import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@abbyy/theming';
import App from './App';
import './assets/fonts/font-faces.css';
import './libs/i18n';
import { ThemeProvider } from '@abbyy/theming';
import { theme } from 'config/theme';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { NotificationManager } from './libs/notification';
import {
    EventListProvider,
    SidenavProvider,
    BlockNavigationProvider,
    SortProvider,
    FilterProvider
} from './providers';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { queryClient } from './utils/queryClient';

ReactDOM.createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ThemeProvider theme={theme} isRoot={true}>
            <CssBaseline />
            <StyledThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <BlockNavigationProvider>
                        <NotificationManager>
                            <SidenavProvider>
                                <EventListProvider>
                                    <SortProvider>
                                        <FilterProvider>
                                            <App />
                                        </FilterProvider>
                                    </SortProvider>
                                </EventListProvider>
                            </SidenavProvider>
                        </NotificationManager>
                    </BlockNavigationProvider>
                    <ReactQueryDevtools position="bottom-right" />
                </QueryClientProvider>
            </StyledThemeProvider>
        </ThemeProvider>
    </StrictMode>
);
